<template>
  <div class="app-container xmzk_zlbb">
    <div>
      <div class="card card6" v-if="zbfxPermission">
        <div class="card-header">
          <div class="card-title">
            <div>指标情况分析</div>
          </div>
        </div>
        <div class="content">
          <div>
            <div>
              <el-date-picker
                v-model="params6.year"
                type="year"
                size="small"
                placeholder="选择年"
                style="width: 100px"
                @change="handleGetList6"
                :clearable="false"
              >
              </el-date-picker>
            </div>
            <div>
              <span>选择季度：</span>
              <el-select
                v-model="params6.jd"
                placeholder=""
                style="width: 120px"
                size="small"
                class="filter-item"
                @change="handleGetList6"
              >
                <el-option
                  v-for="item in jdOption"
                  :key="item.key"
                  :label="item.key"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div>
              <span>选择指标：</span>
              <el-select
                ref="zkjgid"
                v-model="params6.zbid"
                placeholder=""
                style="width: 250px"
                size="small"
                class="filter-item"
                multiple
                collapse-tags
                clearable
                filterable
                @change="handleGetList6"
              >
                <el-option
                  v-for="item in zbList"
                  :key="+item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </div>
            <div>
              <span>分公司：</span>
              <el-select
                v-model="params6.bmbh"
                placeholder="选择分公司"
                clearable
                filterable
                size="small"
                style="width: 180px"
                class="filter-item"
                @change="handleGetList6"
                multiple
                collapse-tags
              >
                <el-option
                  v-for="item in bmList"
                  :key="item.bmbh"
                  :label="item.bmmc"
                  :value="item.bmbh"
                ></el-option>
              </el-select>
            </div>
            <div>
              <el-button
                label="left"
                type="primary"
                size="mini"
                @click="handleExportWeb('指标情况分析', 'list6')"
              >
                导出
              </el-button>
            </div>
          </div>
          <div>
            <el-table
              :data="list6"
              fit
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
              border
              :header-cell-style="tableHeaderColor"
              max-height="400"
              id="list6"
            >
              <el-table-column
                label="指标名称"
                align="center"
                prop="zbmc"
                min-width="80px"
                :show-overflow-tooltip="true"
                key="1"
              />
              <el-table-column
                label="合格数"
                align="center"
                prop="hg"
                min-width="60px"
                key="2"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList6Data(scope.row, '3')"
                    v-if="scope.row.hg != 0"
                  >
                    {{ scope.row.hg }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="不合格数"
                align="center"
                prop="bhg"
                min-width="80px"
                :show-overflow-tooltip="true"
                key="3"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList6Data(scope.row, '4')"
                    v-if="scope.row.bhg != 0"
                  >
                    {{ scope.row.bhg }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="未完成数"
                align="center"
                prop="wwc"
                min-width="80px"
                :show-overflow-tooltip="true"
                key="4"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList6Data(scope.row, '2')"
                    v-if="scope.row.wwc != 0"
                  >
                    {{ scope.row.wwc }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="未开始数"
                align="center"
                prop="wks"
                min-width="60px"
                :show-overflow-tooltip="true"
                key="5"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList6Data(scope.row, '1')"
                    v-if="scope.row.wks != 0"
                  >
                    {{ scope.row.wks }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="延期数"
                align="center"
                prop="yq"
                min-width="80px"
                :show-overflow-tooltip="true"
                key="6"
              > 
              </el-table-column>
              -->
              <el-table-column
                label="豁免数"
                align="center"
                prop="km"
                min-width="80px"
                :show-overflow-tooltip="true"
                key="7"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList6Data(scope.row, '5')"
                    v-if="scope.row.km != 0"
                  >
                    {{ scope.row.km }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="合格率"
                align="center"
                prop="hgl"
                min-width="100px"
                :show-overflow-tooltip="true"
                key="8"
              >
                <template slot-scope="scope"> {{ scope.row.hgl }}% </template>
              </el-table-column>
              <el-table-column
                label="完成率"
                align="center"
                prop="wcl"
                min-width="100px"
                :show-overflow-tooltip="true"
                key="9"
              >
                <template slot-scope="scope"> {{ scope.row.wcl }}% </template>
              </el-table-column>
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
          </div>
        </div>
      </div>
      <div class="card card2" v-if="zbfxPermission">
        <div class="card-header">
          <div class="card-title">
            <div>项目质量分析</div>
          </div>
        </div>
        <div class="content">
          <div>
            <div>
              <el-popover
                placement="bottom"
                width="700"
                trigger="click"
                v-model="list2_popover"
                @show="handleShowList2Pop"
              >
                <div class="card card-zdbj">
                  <div class="card-header">
                    <div class="card-title"><div>选择项目</div></div>
                  </div>
                  <div>
                    <el-form
                      label-width="120px"
                      :hide-required-asterisk="false"
                      style="margin-top: 15px"
                    >
                      <el-form-item label="统计年份：" prop="sjr">
                        <el-date-picker
                          v-model="xmParams.year"
                          type="year"
                          size="small"
                          placeholder="选择年"
                          style="width: 100%"
                          @change="getList2Xm"
                        ></el-date-picker>
                      </el-form-item>

                      <el-form-item label="分公司：" prop="courseGroup">
                        <el-select
                          v-model="xmParams.bmbh"
                          placeholder="选择分公司"
                          clearable
                          filterable
                          size="small"
                          style="width: 100%"
                          class="filter-item"
                          @change="getList2Xm"
                        >
                          <el-option
                            v-for="item in bmList"
                            :key="item.bmbh"
                            :label="item.bmmc"
                            :value="item.bmbh"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="项目阶段" prop="xmjd">
                        <el-select
                          ref="xmjd"
                          v-model="xmParams.xmjd"
                          placeholder="项目阶段"
                          clearable
                          filterable
                          size="small"
                          style="width: 100%"
                          class="filter-item"
                          @change="getList2Xm"
                        >
                          <el-option
                            v-for="item in xmjdList"
                            :key="item.dictValue"
                            :label="item.dictLabel"
                            :value="item.dictValue"
                          />
                        </el-select>
                      </el-form-item>
                      <div class="transfer">
                        <el-transfer
                          v-model="xmCheckList"
                          filterable
                          filter-placeholder="请输入搜索内容"
                          :titles="['未选列表', '已选列表']"
                          :data="xmList"
                          ref="zhbb_transfer"
                          class="transfer-box"
                          :props="{
                            key: 'xmbh',
                            label: 'xmmc',
                          }"
                          @change="handleChangeTransfer"
                        ></el-transfer>
                      </div>
                    </el-form>
                    <div class="zdbj-btn">
                      <el-button
                        label="left"
                        size="mini"
                        @click="resetList2XmParams"
                      >
                        重置
                      </el-button>
                      <el-button
                        label="left"
                        type="primary"
                        size="mini"
                        @click="handleGetList2"
                      >
                        确定
                      </el-button>
                    </div>
                  </div>
                </div>
                <el-button
                  label="left"
                  type="primary"
                  size="mini"
                  slot="reference"
                >
                  选择项目
                </el-button>
              </el-popover>
            </div>
            <div>
              <span>选择季度：</span>
              <el-select
                v-model="params2.jd"
                placeholder=""
                style="width: 120px"
                size="small"
                class="filter-item"
                @change="handleGetList2"
              >
                <el-option
                  v-for="item in jdOption"
                  :key="item.key"
                  :label="item.key"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div>
              <el-button
                label="left"
                type="primary"
                size="mini"
                @click="handleExportWeb('项目质量分析', 'list2')"
              >
                导出
              </el-button>
            </div>
          </div>
          <div>
            <el-table
              :max-height="400"
              :data="list2"
              fit
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
              border
              :header-cell-style="tableHeaderColor"
              id="list2"
            >
              <!-- <el-table-column
                label="统计年份"
                align="center"
                prop="tjnf"
                min-width="80px"
                :show-overflow-tooltip="true"
              /> -->
              <el-table-column
                label="所属部门"
                align="center"
                prop="bmmc"
                min-width="80px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="项目名称"
                align="center"
                prop="xmmc"
                min-width="180px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div class="text_btn" @click="toZk(scope.row)">
                    {{ scope.row.xmmc }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="合格数"
                align="center"
                prop="hgs"
                min-width="100px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList2Data(scope.row, '3')"
                    v-if="scope.row.hgs != 0"
                  >
                    {{ scope.row.hgs }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="不合格数"
                align="center"
                prop="bhgs"
                min-width="100px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList2Data(scope.row, '4')"
                    v-if="scope.row.bhgs != 0"
                  >
                    {{ scope.row.bhgs }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>

              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
          </div>
        </div>
      </div>

      <div class="card card3">
        <div class="card-header">
          <div class="card-title">
            <div>分公司项目总体质量情况</div>
          </div>
        </div>
        <div class="content">
          <div>
            <div>
              <el-date-picker
                v-model="params3.year"
                type="year"
                size="small"
                placeholder="选择年"
                style="width: 100px"
                @change="handleGetList3"
                :clearable="false"
              >
              </el-date-picker>
            </div>
            <div>
              <span>选择季度：</span>
              <el-select
                v-model="params3.jd"
                placeholder=""
                style="width: 120px"
                size="small"
                class="filter-item"
                @change="handleGetList3"
              >
                <el-option
                  v-for="item in jdOption"
                  :key="item.key"
                  :label="item.key"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div>
              <el-button
                label="left"
                type="primary"
                size="mini"
                @click="handleExportWeb('分公司项目总体质量情况', 'list3')"
              >
                导出
              </el-button>
            </div>
          </div>
          <div>
            <el-table
              :data="list3"
              fit
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
              border
              :header-cell-style="tableHeaderColor"
              id="list3"
            >
              <!-- <el-table-column
                label="统计年份"
                align="center"
                prop="tjnf"
                min-width="80px"
                :show-overflow-tooltip="true"
              /> -->
              <el-table-column
                label="分公司"
                align="center"
                prop="bmmc"
                min-width="80px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="项目数"
                align="center"
                prop="xms"
                min-width="60px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="getDialogList3Data(scope.row)"
                    v-if="scope.row.xms != 0"
                  >
                    {{ scope.row.xms }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="合格指标数"
                align="center"
                prop="hgs"
                min-width="80px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList3DataZb(scope.row, '3')"
                    v-if="scope.row.hgs != 0"
                  >
                    {{ scope.row.hgs }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="不合格指标数"
                align="center"
                prop="bhgs"
                min-width="80px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList3DataZb(scope.row, '4')"
                    v-if="scope.row.bhgs != 0"
                  >
                    {{ scope.row.bhgs }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="未完成指标数"
                align="center"
                prop="wwc"
                min-width="80px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList3DataZb(scope.row, '2')"
                    v-if="scope.row.wwc != 0"
                  >
                    {{ scope.row.wwc }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="未开始指标数"
                align="center"
                prop="wks"
                min-width="80px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList3DataZb(scope.row, '1')"
                    v-if="scope.row.wks != 0"
                  >
                    {{ scope.row.wks }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="延期数"
                align="center"
                prop="yq"
                min-width="60px"
                :show-overflow-tooltip="true"
              /> -->
              <el-table-column
                label="豁免数"
                align="center"
                prop="km"
                min-width="60px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList3DataZb(scope.row, '5')"
                    v-if="scope.row.km != 0"
                  >
                    {{ scope.row.km }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="合格率"
                align="center"
                prop="hgl"
                min-width="100px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope"> {{ scope.row.hgl }}% </template>
              </el-table-column>
              <el-table-column
                label="完成率"
                align="center"
                prop="wcl"
                min-width="100px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope"> {{ scope.row.wcl }}% </template>
              </el-table-column>
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
          </div>
        </div>
      </div>

      <div class="card card4">
        <div class="card-header">
          <div class="card-title">
            <div>分公司项目质量明细</div>
          </div>
        </div>
        <div class="content">
          <div>
            <div>
              <el-date-picker
                v-model="params4.year"
                type="year"
                size="small"
                placeholder="选择年"
                style="width: 100px"
                @change="handleGetList4"
                :clearable="false"
              >
              </el-date-picker>
            </div>
            <div>
              <span>选择季度：</span>
              <el-select
                v-model="params4.jd"
                placeholder=""
                style="width: 120px"
                size="small"
                class="filter-item"
                @change="handleGetList4"
              >
                <el-option
                  v-for="item in jdOption"
                  :key="item.key"
                  :label="item.key"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div>
              <span>分公司：</span>
              <el-select
                v-model="params4.bmbh"
                placeholder="选择分公司"
                clearable
                filterable
                size="small"
                style="width: 180px"
                class="filter-item"
                @change="handleGetList4"
                multiple
                collapse-tags
              >
                <el-option
                  v-for="item in bmList"
                  :key="item.bmbh"
                  :label="item.bmmc"
                  :value="item.bmbh"
                ></el-option>
              </el-select>
            </div>
            <div>
              <el-button
                label="left"
                type="primary"
                size="mini"
                @click="handleExportWeb('分公司项目质量明细', 'list4')"
              >
                导出
              </el-button>
            </div>
          </div>
          <div>
            <el-table
              :max-height="400"
              :data="list4"
              fit
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
              border
              :header-cell-style="tableHeaderColor"
              :span-method="objectSpanMethod"
              id="list4"
            >
              <el-table-column
                label="分公司"
                align="center"
                prop="bmmc"
                min-width="100px"
                :show-overflow-tooltip="true"
                fixed
              />
              <el-table-column
                label="区域总监"
                align="center"
                prop="qyzj"
                min-width="80px"
                :show-overflow-tooltip="true"
                fixed
              />
              <el-table-column
                label="项目名称"
                align="center"
                prop="bmmc"
                min-width="200px"
                :show-overflow-tooltip="true"
                fixed
              >
                <template slot-scope="scope">
                  <div class="text_btn" @click="toZk(scope.row)">
                    {{ scope.row.xmmc }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="合格指标数"
                align="center"
                prop="hgs"
                min-width="100px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList4Data(scope.row, '3')"
                    v-if="scope.row.hgs != 0"
                  >
                    {{ scope.row.hgs }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="不合格指标数"
                align="center"
                prop="bhgs"
                min-width="100px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList4Data(scope.row, '4')"
                    v-if="scope.row.bhgs != 0"
                  >
                    {{ scope.row.bhgs }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="未完成指标数"
                align="center"
                prop="wwc"
                min-width="100px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList4Data(scope.row, '2')"
                    v-if="scope.row.wwc != 0"
                  >
                    {{ scope.row.wwc }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="未开始指标数"
                align="center"
                prop="wks"
                min-width="100px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList4Data(scope.row, '1')"
                    v-if="scope.row.wks != 0"
                  >
                    {{ scope.row.wks }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="豁免数"
                align="center"
                prop="km"
                min-width="100px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList4Data(scope.row, '5')"
                    v-if="scope.row.km != 0"
                  >
                    {{ scope.row.km }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="完成率"
                align="center"
                prop="wcl"
                min-width="150px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope"> {{ scope.row.wcl }}% </template>
              </el-table-column>

              <el-table-column
                label="区域平均完成率"
                align="center"
                prop="pjl"
                min-width="150px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  {{ scope.row.qypjwcl }}%
                </template>
              </el-table-column>

              <el-table-column
                label="合格率"
                align="center"
                prop="wcl"
                min-width="150px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope"> {{ scope.row.hgl }}% </template>
              </el-table-column>

              <el-table-column
                label="区域平均合格率"
                align="center"
                prop="pjl"
                min-width="150px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  {{ scope.row.qypjhgl }}%
                </template>
              </el-table-column>
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
          </div>
        </div>
      </div>
      <div class="card card5" v-if="adminRole">
        <div class="card-header">
          <div class="card-title">
            <div>质量扣罚统计</div>
          </div>
        </div>
        <div class="content">
          <div style="margin-bottom: 15px">
            <div>
              <el-date-picker
                v-model="params5.year"
                type="year"
                size="small"
                placeholder="选择年"
                style="width: 100px"
                @change="handleGetList5"
                :clearable="false"
              >
              </el-date-picker>
            </div>
            <div>
              <span>选择季度：</span>
              <el-select
                v-model="params5.jd"
                placeholder=""
                style="width: 120px"
                size="small"
                class="filter-item"
                @change="handleGetList5"
              >
                <el-option
                  v-for="item in jdOption"
                  :key="item.key"
                  :label="item.key"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div>
              <el-button
                label="left"
                type="primary"
                size="mini"
                @click="handleExportWeb('质量扣罚统计', 'list5')"
              >
                导出
              </el-button>
            </div>
          </div>
          <div>
            <el-table
              :data="list5"
              fit
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
              border
              :header-cell-style="tableHeaderColor"
              show-summary
              ref="table5"
              :table-footer-template="getFooterTemplate"
              id="list5"
            >
              <el-table-column
                label="分公司"
                align="center"
                prop="bmmc"
                min-width="120px"
                :show-overflow-tooltip="true"
                fixed
              />
              <el-table-column
                v-for="i in dtzbList"
                :key="i.zbmc"
                :label="i.zbmc"
                align="center"
                :prop="i.zbmc"
                min-width="80px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    class="text_btn"
                    @click="handleDialogList5Data(scope.row, i.zbid, i.zbmc)"
                    v-if="scope.row[i.zbmc] != 0"
                  >
                    {{ scope.row[i.zbmc] }}
                  </div>
                  <div v-else>0</div>
                </template>
              </el-table-column>
              <el-table-column
                label="扣罚结果"
                align="center"
                fixed="right"
                width="160px"
              >
                <el-table-column
                  label="分公司"
                  align="center"
                  prop="fgs"
                  min-width="80px"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div style="color: #f90000">
                      {{ scope.row.fgs }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="分公司总经理"
                  align="center"
                  prop="fgszjl"
                  min-width="80px"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div style="color: #f90000">
                      {{ scope.row.fgszjl }}
                    </div>
                  </template>
                </el-table-column>
              </el-table-column>
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="`项目情况分析-${xmzlListTitle}`"
      :visible.sync="list1Dialog"
      width="900px"
      :closeOnClickModal="false"
      v-if="list1Dialog"
      :show-close="false"
    >
      <div>
        <el-table
          :max-height="400"
          :data="xmzlList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          border
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column
            label="所属部门"
            align="center"
            prop="bmmc"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="项目名称"
            align="center"
            prop="xmmc"
            min-width="200px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="list1Dialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="`项目质量分析-${list2Title}`"
      :visible.sync="list2Dialog"
      width="900px"
      :closeOnClickModal="false"
      v-if="list2Dialog"
      :show-close="false"
    >
      <template #title>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <span>分公司项目质量明细</span>
          <el-button
            label="left"
            type="primary"
            size="mini"
            @click="handleExportWeb('分公司项目质量明细', 'list12')"
          >
            导出
          </el-button>
        </div>
      </template>

      <div>
        <el-table
          :max-height="400"
          :data="list2_dialog_data"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          border
          :header-cell-style="tableHeaderColor"
          id="list12"
        >
          <el-table-column
            label="季度指标"
            align="center"
            prop="jd"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="半年度指标"
            align="center"
            prop="bnd"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="年度指标"
            align="center"
            prop="nd"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="list2Dialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="`分公司项目质量明细`"
      :visible.sync="list3Dialog"
      width="900px"
      :closeOnClickModal="false"
      :show-close="false"
    >
      <template #title>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <span>分公司项目质量明细</span>
          <el-button
            label="left"
            type="primary"
            size="mini"
            @click="handleExportWeb('分公司项目质量明细', 'list7')"
          >
            导出
          </el-button>
        </div>
      </template>

      <div>
        <el-table
          :max-height="400"
          :data="dialog_list_3"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          border
          :header-cell-style="tableHeaderColor"
          id="list7"
        >
          <el-table-column
            label="所属部门"
            align="center"
            prop="bmmc"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="项目名称"
            align="center"
            prop="xmmc"
            min-width="200px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div class="text_btn" @click="toZk(scope.row)">
                {{ scope.row.xmmc }}
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="list3Dialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="`${list3TitleZb}`"
      :visible.sync="list3DialogZb"
      width="900px"
      :closeOnClickModal="false"
      v-if="list3DialogZb"
      :show-close="false"
    >
      <div class="dialog-input">
        <div class="input-col">
          <div>指标名称：</div>
          <div>
            <el-input
              placeholder="请输入指标名称"
              v-model="params3Dialog.zbmc"
              class="input-with-select"
              size="mini"
              maxlength="50"
              @input="
                (e) => {
                  debounce(getList3ZbDialogData, 500);
                }
              "
            >
            </el-input>
          </div>
        </div>
        <div class="input-col">
          <div>项目名称：</div>
          <div>
            <el-input
              placeholder="请输入项目名称"
              v-model="params3Dialog.xmmc"
              class="input-with-select"
              size="mini"
              maxlength="50"
              @input="
                (e) => {
                  debounce(getList3ZbDialogData, 500);
                }
              "
            >
            </el-input>
          </div>
        </div>
        <div class="input-col">
          <el-button
            label="left"
            type="primary"
            size="mini"
            @click="handleExportWeb(`${list3TitleZb}`, 'list8')"
          >
            导出
          </el-button>
        </div>
      </div>
      <div>
        <el-table
          :max-height="400"
          :data="dialog_list_3_zb"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          border
          :header-cell-style="tableHeaderColor"
          id="list8"
        >
          <el-table-column
            label="项目名称"
            align="center"
            prop="xmmc"
            min-width="120px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="季度指标"
            align="center"
            prop="jd"
            min-width="140px"
          />
          <el-table-column
            label="半年度指标"
            align="center"
            prop="bnd"
            min-width="140px"
          />
          <el-table-column
            label="年度指标"
            align="center"
            prop="nd"
            min-width="140px"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="list3DialogZb = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="`${list4TitleZb}`"
      :visible.sync="list4DialogZb"
      width="900px"
      :closeOnClickModal="false"
      :show-close="false"
    >
      <template #title>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <span>{{ list4TitleZb }}</span>
          <el-button
            label="left"
            type="primary"
            size="mini"
            @click="handleExportWeb(`${list4TitleZb}`, 'list9')"
          >
            导出
          </el-button>
        </div>
      </template>

      <div>
        <el-table
          :max-height="400"
          :data="dialog_list_4_zb"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          border
          :header-cell-style="tableHeaderColor"
          id="list9"
        >
          <el-table-column
            label="季度指标"
            align="center"
            prop="jd"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="半年度指标"
            align="center"
            prop="bnd"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="年度指标"
            align="center"
            prop="nd"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="list4DialogZb = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="`${dialog_list_6_zb.title}`"
      :visible.sync="list6Dialog"
      width="900px"
      :closeOnClickModal="false"
      v-if="list6Dialog"
      :show-close="false"
    >
      <div class="dialog-input">
        <div>项目名称：</div>
        <div>
          <el-input
            placeholder="请输入项目名称"
            v-model="params6.xmmc"
            class="input-with-select"
            size="mini"
            maxlength="50"
            @input="
              (e) => {
                dialog_list_6_zb.page = 1;
                getList6DialogData();
              }
            "
          >
          </el-input>
        </div>
        <div class="input-col">
          <!-- <el-button
                label="left"
                type="primary"
                size="mini"
                @click="handleExportWeb(`${dialog_list_6_zb.title}`, 'list11')"
              >
                导出
              </el-button> -->
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            style="margin-left: 15px"
            >导出</el-button
          >
        </div>
      </div>
      <div>
        <el-table
          :max-height="400"
          :data="dialog_list_6_zb.list"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          border
          :header-cell-style="tableHeaderColor"
          id="list11"
        >
          <el-table-column
            label="指标名称"
            align="center"
            prop="zbmc"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="项目名称"
            align="center"
            prop="xmmc"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="dialog_list_6_zb.total > 0"
          :total="dialog_list_6_zb.total"
          :page.sync="dialog_list_6_zb.page"
          :limit.sync="dialog_list_6_zb.pageSize"
          @pagination="getList6DialogData"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="list6Dialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="`${dialog_list_5_zb.title}`"
      :visible.sync="list5Dialog"
      width="900px"
      :closeOnClickModal="false"
      v-if="list5Dialog"
      :show-close="false"
    >
      <div class="dialog-input">
        <div>项目名称：</div>
        <div>
          <el-input
            placeholder="请输入项目名称"
            v-model="params5.xmmc"
            class="input-with-select"
            size="mini"
            maxlength="50"
            @input="
              (e) => {
                dialog_list_5_zb.page = 1;
                getList5DialogData();
              }
            "
          >
          </el-input>
        </div>

        <div class="input-col">
          <el-button
            label="left"
            type="primary"
            size="mini"
            @click="handleExportWeb(`${dialog_list_5_zb.title}`, 'list10')"
          >
            导出
          </el-button>
        </div>
      </div>

      <div>
        <el-table
          :max-height="400"
          :data="dialog_list_5_zb.list"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          border
          :header-cell-style="tableHeaderColor"
          id="list10"
        >
          <el-table-column
            label="分公司"
            align="center"
            prop="dept_name"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="项目名称"
            align="center"
            prop="xmmc"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="指标名称"
            align="center"
            prop="zbmc"
            min-width="80px"
            :show-overflow-tooltip="true"
          />

          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="dialog_list_5_zb.total > 0"
          :total="dialog_list_5_zb.total"
          :page.sync="dialog_list_5_zb.page"
          :limit.sync="dialog_list_5_zb.pageSize"
          @pagination="getList5DialogData"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="list5Dialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getDictData } from "@/api/weekly.js";
import {
  getFgsList,
  getKfbzList,
  getXmxxList,
  getXmzlList,
  getXmzlfxList,
  getXmzlfxzbmxList,
  getXmzlmxList,
  getXmzlqkzbmxList,
  getXmztzlqkList,
  getZbmcDtList,
  getZbmcList,
  getZbqkfxList,
  getZbqktjList,
  getZtzlxmsList,
  getZtzlzbmxList,
  zhbbExport,
  getZbgkfxMxList,
  getKftjMxList,
} from "@/api/xmzk";
import moment from "moment";
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination";

// import { debounce } from "@/utils/utils.js";
export default {
  computed: {
    ...mapGetters(["user"]),
  },
  components: { Pagination },
  data() {
    return {
      year: null,
      radio: 1,
      zbList: [],
      dtzbList: [],
      params1: {
        year: moment(),
        zbid: [],
        // jd: null,
      },
      params2: {
        jd: null,
      },
      xmParams: {
        bmbh: null,
        xmjd: null,
        xmmc: null,
        year: moment(),
        jd: null,
      },
      params3: {
        year: moment(),
        jd: null,
      },
      params3Dialog: {
        xmmc: null,
        zbmc: null,
        status: null,
      },
      params4: {
        year: moment(),
        bmbh: [],
        jd: null,
      },
      params5: {
        year: moment(),
        jd: null,
        xmmc: null,
      },
      params6: {
        year: moment(),
        zbid: [],
        jd: null,
        bmbh: [],
        xmmc: null,
      },
      jdOption: [
        {
          key: "全部",
          value: "",
        },
        {
          key: "一季度",
          value: "1",
        },
        {
          key: "二季度",
          value: "2",
        },

        {
          key: "三季度",
          value: "3",
        },
        {
          key: "四季度",
          value: "4",
        },
      ],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      list6: [],

      list7: [], //分公司项目总体质量情况-项目（表三）
      list8: [], //分公司项目总体质量情况-指标（表三）
      list9: [], //分公司项目质量明细-指标（表四）
      list10: [], //质量扣罚明细导出（表五）
      list11: [], //指标情况分析-明细(表一)
      list12: [], //项目质量分析-明细（表二）

      list1Dialog: false,
      list2Dialog: false,
      list3Dialog: false,
      list3DialogZb: false,
      list4DialogZb: false,
      list5Dialog: false,
      list6Dialog: false,

      list7Dialog: false,
      list8Dialog: false,
      list9Dialog: false,
      list10Dialog: false,
      list11Dialog: false,
      list12Dialog: false,

      xmzlListTitle: "",
      xmjdList: [],
      bmList: [],
      dialog_list_3: [],
      xmList: [],
      xmCheckList: [],
      list2_popover: false,
      list2_dialog_data: [],
      dialog_list_3_zb: [],
      dialog_list_4_zb: [],
      dialog_list_6_zb: {
        zxjg: null,
        zbid: null,
        page: 1,
        pageSize: 10,
        total: 0,
        title: null,
        list: [],
      },
      dialog_list_5_zb: {
        zbid: null,
        page: 1,
        pageSize: 10,
        total: 0,
        title: null,
        bmbh: null,
        list: [],
      },
      list2Title: "",
      list3TitleZb: "",
      adminRole: false,
      zbfxPermission: false,
      xmCheckListCopy: [],
      timer: null,
    };
  },
  created() {
    if (!this.user.xm) {
      this.$store.dispatch("common/fetchUserInfoAction").then((res) => {
        this.handleGetList3();
        this.handleGetList4();
        if (this.user.roleName.indexOf("质控管理-综合报表扣罚统计查看") > -1) {
          this.adminRole = true;
          //this.zbfxPermission = true;
          // this.handleGetList1();
          // this.handleGetList2();
          this.handleGetList5();
          //this.handleGetList6();
        }
        if (this.user.roleName.indexOf("质控管理-指标情况分析") > -1) {
          this.zbfxPermission = true;
          this.handleGetList2();
          this.handleGetList6();
        }
      });
    } else {
      this.handleGetList3();
      this.handleGetList4();
      if (this.user.roleName.indexOf("质控管理-综合报表扣罚统计查看") > -1) {
        this.adminRole = true;
        //this.zbfxPermission = true;
        // this.handleGetList1();
        // this.handleGetList2();
        this.handleGetList5();
        //this.handleGetList6();
      }
      if (this.user.roleName.indexOf("质控管理-指标情况分析") > -1) {
        this.zbfxPermission = true;
        this.handleGetList2();
        this.handleGetList6();
      }
    }
    getZbmcList().then((res) => {
      if (res.code == 0) {
        this.zbList = res.data;
      }
    });

    // 获取项目阶段数据
    getDictData("xmjd", 2).then((res) => {
      if (res.code == 0) {
        this.xmjdList = res.data.splice(1, 4);
      }
    });
    getFgsList().then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });
    this.getList2Xm();
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document.querySelector(".xmzk_zlbb").parentNode.style.overflow =
          "hidden";
        document.querySelector(".xmzk_zlbb").parentNode.style.height = "100%";
        document.querySelector(".xmzk_zlbb").parentNode.style.overflow = "auto";
        if (this.user.roleName.indexOf("质控管理-综合报表扣罚统计查看") > -1) {
          if (this.$refs.table5.$refs.footerWrapper) {
            var current =
              this.$refs.table5.$refs.footerWrapper.querySelector(
                ".el-table__footer"
              );
            var cell = current.rows[0].cells;
            var len = cell.length;
            for (let i in cell) {
              if (i == len - 3 || i == len - 2)
                cell[i].className = `${cell[i].className} red-cell `;
            }
          }
        }
      }, 500);
    });
  },
  methods: {
    getJdLastDay(jd) {
      if (jd == 1) {
        return "0331";
      } else if (jd == 2) {
        return "0630";
      } else if (jd == 3) {
        return "0930";
      } else {
        return "1231";
      }
    },
    getJdFirstDay(jd) {
      if (jd == 1) {
        return "0101";
      } else if (jd == 2) {
        return "0401";
      } else if (jd == 3) {
        return "0701";
      } else if (jd == 4) {
        return "1001";
      } else {
        return "0101";
      }
    },
    handleGetList1() {
      const data = {
        year: moment(this.params1.year).format("YYYY"),
        zbid: this.params1.zbid.join(","),
        // ssjd: this.params1.jd,
      };

      getZbqkfxList(data).then((res) => {
        if (res.code == 0) {
          this.list1 = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleGetList2() {
      this.list2_popover = false;
      getXmzlfxList({
        xmbh: this.xmCheckList.join(","),
        jcnf: moment(this.xmParams.year).format("YYYY"),
        ssjd: this.params2.jd ? this.params2.jd : "-1",
        tjrq: `${moment(this.xmParams.year).format("YYYY")}${this.getJdLastDay(
          this.params2.jd
        )}`,
      }).then((res) => {
        if (res.code == 0) {
          this.list2 = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleGetList3() {
      const data = {
        year: moment(this.params3.year).format("YYYY"),
        ygbh: this.user.ygbh,
        qyzj:
          this.user.roleId.indexOf("111") > -1 ||
          this.user.roleId.indexOf("112") > -1
            ? this.user.roleId.indexOf("134") > -1
              ? ""
              : this.user.ygbh
            : "",
        ssjd: this.params3.jd ? this.params3.jd : "-1",
        tjrq: `${moment(this.params3.year).format("YYYY")}${this.getJdLastDay(
          this.params3.jd
        )}`,
      };
      getXmztzlqkList(data).then((res) => {
        if (res.code == 0) {
          this.list3 = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleGetList4() {
      const data = {
        year: moment(this.params4.year).format("YYYY"),
        bmbh: this.params4.bmbh.join(","),
        ygbh: this.user.ygbh,
        qyzj:
          this.user.roleId.indexOf("111") > -1 ||
          this.user.roleId.indexOf("112") > -1
            ? this.user.roleId.indexOf("134") > -1
              ? ""
              : this.user.ygbh
            : "",
        ssjd: this.params4.jd ? this.params4.jd : "-1",
        tjrq: `${moment(this.params4.year).format("YYYY")}${this.getJdLastDay(
          this.params4.jd
        )}`,
      };

      getXmzlmxList(data).then((res) => {
        if (res.code == 0) {
          this.list4 = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleGetList5() {
      const data = {
        year: moment(this.params5.year).format("YYYY"),
        ssjd: this.params5.jd ? this.params5.jd : "-1",
        // qsrq: this.params5.jd.slice(0, 4),
        // jsrq: this.params5.jd.slice(-4),
        tjrq: `${moment(this.params5.year).format("YYYY")}${this.getJdLastDay(
          this.params5.jd
        )}`,
      };
      // const data2 = {
      //   tjrq: `${moment(this.params5.year).format("YYYY")}${this.getJdFirstDay(
      //     this.params5.jd
      //   )}`,
      // };
      getZbmcDtList(data).then((res) => {
        if (res.code == 0) {
          this.dtzbList = res.data;
          getKfbzList(data).then((res2) => {
            if (res2.code == 0) {
              this.list5 = res2.data;
            } else {
              this.$message.error(res22.msg);
            }
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleGetList6() {
      const data = {
        year: moment(this.params6.year).format("YYYY"),
        zbid: this.params6.zbid.join(","),
        ssjd: this.params6.jd ? this.params6.jd : "-1",
        bmbh: this.params6.bmbh.join(","),
        tjrq: `${moment(this.params6.year).format("YYYY")}${this.getJdLastDay(
          this.params6.jd
        )}`,
      };

      getZbqktjList(data).then((res) => {
        if (res.code == 0) {
          this.list6 = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getXmzlListData(row, status) {
      const data = {
        year: row.tjnf,
        zbid: row.zbid,
        sfhg: status,
        ssjd: this.params1.jd ? this.params1.jd : "-1",
        tjrq: `${moment(row.tjnf).format("YYYY")}${this.getJdLastDay(
          this.params1.jd
        )}`,
      };
      this.xmzlListTitle = status.indexOf("3") > -1 ? "合格项目" : "不合格项目";
      getXmzlList(data).then((res) => {
        if (res.code == 0) {
          this.xmzlList = res.data;
          this.list1Dialog = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    handleExport() {
      const data = {};
      data.year = moment(this.params6.year).format("YYYY");
      data.zbid = this.dialog_list_6_zb.zbid;
      data.ssjd = this.params6.jd ? this.params6.jd : "-1";
      data.bmbh = this.params6.bmbh ? this.params6.bmbh.join(',') : "";
      data.zxjg = this.dialog_list_6_zb.zxjg;
      data.xmmc = this.params6.xmmc;
      data.tjrq = `${moment(this.params6.year).format(
        "YYYY"
      )}${this.getJdLastDay(this.params6.jd)}`;
      console.log(data);
     
      zhbbExport(data).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    getDialogList3Data(row) {
      getZtzlxmsList({
        year: row.tjnf,
        bmbh: row.bmbh,
        qyzj:
          this.user.roleId.indexOf("111") > -1 ||
          this.user.roleId.indexOf("112") > -1
            ? this.user.roleId.indexOf("134") > -1
              ? ""
              : this.user.ygbh
            : "",
        ssjd: this.params3.jd ? this.params3.jd : "-1",
        tjrq: `${moment(row.tjnf).format("YYYY")}${this.getJdLastDay(
          this.params3.jd
        )}`,
      }).then((res) => {
        if (res.code == 0) {
          this.dialog_list_3 = res.data;
          this.list3Dialog = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    getDialogList2Data(row, status) {
      const data = {
        year: row.tjnf,
        zbid: row.zbid,
        sfhg: status,
      };
      this.xmzlListTitle = status == 3 ? "合格项目" : "不合格项目";
      getXmzlList(data).then((res) => {
        if (res.code == 0) {
          this.xmzlList = res.data;
          this.list1Dialog = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getList2Xm() {
      getXmxxList({
        ...this.xmParams,
        year: moment(this.xmParams.year).format("YYYY"),
      }).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
          this.xmList.push(...this.xmCheckListCopy);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleShowList2Pop() {
      // this.xmCheckList = [];
      // this.xmCheckListCopy = [];
      // this.xmParams = {
      //   bmbh: null,
      //   xmjd: null,
      //   xmmc: null,
      //   year: moment(),
      // };
      if (this.xmList.length == 0) {
        this.getList2Xm();
      }
    },
    handleDialogList2Data(row, status) {
      this.list2Dialog = true;
      this.list2Title = `${row.xmmc}(${
        status.indexOf("3") > -1 ? "合格指标" : "不合格指标"
      })`;
      getXmzlfxzbmxList({
        xmbh: row.xmbh,
        zxjg: status,
        jcnf: row.tjnf,
        ssjd: this.params2.jd ? this.params2.jd : "-1",
        tjrq: `${moment(row.tjnf).format("YYYY")}${this.getJdLastDay(
          this.params2.jd
        )}`,
      }).then((res) => {
        if (res.code == 0) {
          this.list2_dialog_data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    toZk(row) {
      var dataUrl = `/menuRedirect?systemType=tmis-pmp&redireType=tmis&menuType=40&zk_xmbh=${row.xmbh}`;
      var menuName = "过程检查";
      var dataIndex = Math.round(Math.random() * 10000);
      localStorage.setItem("zk_xmbh", row.xmbh);
      var data = { dataIndex, dataUrl, menuName };
      // window.parent.menuItemInPage(dataUrl, dataIndex, menuName);
      window.parent.postMessage(data, "*");
      // this.$router.push({
      //   path: "/xmzk/index",
      //   query: { xmbh: row.xmbh },
      // });
    },
    handleChangeTransfer() {
      setTimeout(() => {
        this.xmCheckListCopy = this.$refs.zhbb_transfer.targetData;
      }, 50);
    },
    handleDialogList3DataZb(row, status) {
      this.list3DialogZb = true;
      if (status == 3) {
        this.list3TitleZb = `${row.bmmc}项目总体质量情况(合格指标)`;
      } else if (status == 4) {
        this.list3TitleZb = `${row.bmmc}项目总体质量情况(不合格指标)`;
      } else if (status == 2) {
        this.list3TitleZb = `${row.bmmc}项目总体质量情况(未完成指标)`;
      } else if (status == 1) {
        this.list3TitleZb = `${row.bmmc}项目总体质量情况(未开始指标)`;
      } else {
        this.list3TitleZb = `${row.bmmc}项目总体质量情况(豁免指标)`;
      }

      this.params3Dialog = {
        tjnf: row.tjnf,
        bmbh: row.bmbh,
        xmmc: null,
        zbmc: null,
        status,
      };

      this.getList3ZbDialogData();
    },
    getList3ZbDialogData() {
      getZtzlzbmxList({
        year: this.params3Dialog.tjnf,
        bmbh: this.params3Dialog.bmbh,
        qyzj:
          this.user.roleId.indexOf("111") > -1 ||
          this.user.roleId.indexOf("112") > -1
            ? this.user.roleId.indexOf("134") > -1
              ? ""
              : this.user.ygbh
            : "",
        ssjd: this.params3.jd ? this.params3.jd : "-1",
        zxjg: this.params3Dialog.status,
        xmmc: this.params3Dialog.xmmc,
        zbmc: this.params3Dialog.zbmc,
        tjrq: `${moment(this.params3.year).format("YYYY")}${this.getJdLastDay(
          this.params3.jd
        )}`,
      }).then((res) => {
        if (res.code == 0) {
          this.dialog_list_3_zb = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleDialogList4Data(row, status) {
      if (status == 3) {
        this.list4TitleZb = `项目质量明细-${row.xmmc}(合格指标)`;
      } else if (status == 4) {
        this.list4TitleZb = `项目质量明细-${row.xmmc}(不合格指标)`;
      } else if (status == 2) {
        this.list4TitleZb = `项目质量明细-${row.xmmc}(未完成指标)`;
      } else if (status == 1) {
        this.list4TitleZb = `项目质量明细-${row.xmmc}(未开始指标)`;
      } else {
        this.list4TitleZb = `项目质量明细-${row.xmmc}(豁免指标)`;
      }
      this.list4DialogZb = true;

      getXmzlqkzbmxList({
        year: row.tjnf,
        xmbh: row.xmbh,
        qyzj:
          this.user.roleId.indexOf("111") > -1 ||
          this.user.roleId.indexOf("112") > -1
            ? this.user.roleId.indexOf("134") > -1
              ? ""
              : this.user.ygbh
            : "",
        ssjd: this.params4.jd ? this.params4.jd : "-1",
        zxjg: status,
        tjrq: `${moment(row.tjnf).format("YYYY")}${this.getJdLastDay(
          this.params4.jd
        )}`,
      }).then((res) => {
        if (res.code == 0) {
          this.dialog_list_4_zb = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 11 || columnIndex === 9) {
        // return {
        //   rowspan: 2,
        //   colspan: 1,
        // };
        const _row = this.flitterData(this.list4).one[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    flitterData(arr) {
      let spanOneArr = [];
      let concatOne = 0;
      arr.forEach((item, index) => {
        if (index === 0) {
          spanOneArr.push(1);
        } else {
          if (item.qyzj === arr[index - 1]?.qyzj) {
            //第一列需合并相同内容的判断条件
            spanOneArr[concatOne] += 1;
            spanOneArr.push(0);
          } else {
            spanOneArr.push(1);
            concatOne = index;
          }
        }
      });
      return {
        one: spanOneArr,
      };
    },
    getFooterTemplate() {
      return `
         <tfoot>
            <tr @click="handleFooterClick">
               <td>合计</td>
               <!-- 省略其他列 -->
            </tr>
         </tfoot>
      `;
    },
    handleFooterClick() {},
    handleExportWeb(name, id) {
      this.outToExcel.exportExcel(name, id);
    },
    resetList2XmParams() {
      this.xmParams.year = moment();
      this.xmParams.bmbh = null;
      this.xmParams.xmjd = null;
      this.xmCheckList = [];
      this.xmParams.xmmc = null;
      this.xmParams.jd = null;
      this.getList2Xm();
    },
    handleDialogList6Data(row, zxjg) {
      this.dialog_list_6_zb.page = 1;
      this.dialog_list_6_zb.zxjg = zxjg;
      this.dialog_list_6_zb.zbid = row.zbid;
      this.params6.xmmc = null;
      this.getList6DialogData();
      this.list6Dialog = true;
    },
    getList6DialogData() {
      const data = {
        year: moment(this.params6.year).format("YYYY"),
        zbid: this.dialog_list_6_zb.zbid,
        ssjd: this.params6.jd ? this.params6.jd : "-1",
        bmbh: this.params6.bmbh.join(","),
        page: this.dialog_list_6_zb.page,
        zxjg: this.dialog_list_6_zb.zxjg,
        pageSize: this.dialog_list_6_zb.pageSize,
        xmmc: this.params6.xmmc,
        tjrq: `${moment(this.params6.year).format("YYYY")}${this.getJdLastDay(
          this.params6.jd
        )}`,
      };

      getZbgkfxMxList(data).then((res) => {
        if (res.code == 0) {
          this.dialog_list_6_zb.total = res.count;
          this.dialog_list_6_zb.list = res.data;
          this.dialog_list_6_zb.title = res.data[0].zbmc;
          if (this.dialog_list_6_zb.zxjg == 3) {
            this.dialog_list_6_zb.title += "(合格项目)";
          } else if (this.dialog_list_6_zb.zxjg == 4) {
            this.dialog_list_6_zb.title += "(不合格项目)";
          } else if (this.dialog_list_6_zb.zxjg == 2) {
            this.dialog_list_6_zb.title += "(未完成项目)";
          } else if (this.dialog_list_6_zb.zxjg == 1) {
            this.dialog_list_6_zb.title += "(未开始项目)";
          } else {
            this.dialog_list_6_zb.title += "(豁免项目)";
          }
        }
      });
    },
    handleDialogList5Data(row, zbid, zbmc) {
      this.dialog_list_5_zb.zbid = zbid;
      this.dialog_list_5_zb.bmbh = row.bmbh;
      this.dialog_list_5_zb.title = `${row.bmmc}-${zbmc}-扣罚结果`;
      this.params5.xmmc = null;
      this.getList5DialogData();
      this.list5Dialog = true;
      this.dialog_list_5_zb.page = 1;
    },
    getList5DialogData() {
      const data = {
        year: moment(this.params5.year).format("YYYY"),
        zbid: this.dialog_list_5_zb.zbid,
        ssjd: this.params5.jd ? this.params5.jd : "-1",
        bmbh: this.dialog_list_5_zb.bmbh,
        page: this.dialog_list_5_zb.page,
        pageSize: this.dialog_list_5_zb.pageSize,
        xmmc: this.params5.xmmc,
        tjrq: `${moment(this.params5.year).format("YYYY")}${this.getJdLastDay(
          this.params5.jd
        )}`,
      };
      getKftjMxList(data).then((res) => {
        if (res.data) {
          this.dialog_list_5_zb.total = res.count;
          this.dialog_list_5_zb.list = res.data;
        }
      });
    },
    debounce(fn, delay) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        console.log("触发！");
        fn();
        this.timer = null;
      }, delay);
    },
  },
};
</script>
<style lang="less" scoped>
.app-container {
  min-height: 100%;
  min-width: 1200px;
  background-color: #eef2f8;
  padding: 10px;
  box-sizing: border-box;
  font-family: "Arial Negreta" !important;
}

.card1 {
  .content {
    > div {
      margin-bottom: 15px;
    }
  }
}
.card {
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-sizing: border-box;
  margin-bottom: 15px;
  .card-header {
    display: flex;
    justify-content: space-between;
    height: 22px;
    line-height: 22px;
    padding-bottom: 10px;
    border-bottom: 1px solid #efefef;
    .card-title {
      position: relative;
      font-size: 16px;
      font-weight: 700;
      > div {
        padding-left: 15px;
      }
    }
    .card-title::before {
      content: "";
      height: 100%;
      background: #036eb8;
      width: 4px;
      position: absolute;
      border-radius: 4px;
    }
    .card-more {
      color: #999;
      font-size: 13px;
      cursor: pointer;
    }
  }
  .content {
    padding: 15px 15px 0 15px;

    > div:nth-of-type(1) {
      display: flex;
      margin-bottom: 15px;
      > div {
        margin-right: 30px;
        color: #666;
      }
    }
  }
  .zdbj-btn {
    display: flex;
    justify-content: flex-end;
  }
  .transfer {
    display: flex;
    justify-content: space-around;
    margin-bottom: 15px;
  }
  .text_btn {
    cursor: pointer;
    color: #036eb8;
  }
}
.pagination-container {
  margin-top: 15px;
  border: 0;
}
.dialog-input {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 15px;
  align-items: center;
  > .input-col {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-left: 30px;
  }
}
</style>
